import React from "react";
import { blogsData } from "../../data/blog";
import Blogs from "../../pages/blogs/Blogs";
const Article = () => {
  return (
   <><Blogs /></>
  );
};

export default Article;
